<template>
  <v-chip class="bcl-token-label font-heading" size="small">
    <span><slot /></span>
  </v-chip>
</template>

<style lang="scss" scoped>
@use "@/styles/variables" as *;

.bcl-token-label {
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: -0.12em;

  span {
    line-height: 120%;
    height: 10px;
  }
}
</style>
